import BlockTypes from '../../../types/BlockTypes';
export default function isTodoBlock(value) {
  return value.document.getClosestBlock(value.selection.start.key).type === BlockTypes.TODO;
}